import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HealthServices.css';

const HealthServices = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      icon: '🌞',
      title: 'Mind–Body Balance',
      subtitle: 'Discover the planetary patterns that shape your vitality and wellbeing.',
      features: [
        'Holistic Health Astrology Reading',
        'Elemental (Fire–Earth–Air–Water) balance',
        'Planetary influences on health and resilience'
      ]
    },
    {
      id: 2,
      icon: '🕊️',
      title: 'Stress & Recovery Cycles',
      subtitle: 'Understand your personal stress triggers and ideal recharge windows.',
      features: [
        'Stress period prediction',
        'Energy flow & fatigue mapping',
        'Rest and recovery cycle analysis'
      ]
    },
    {
      id: 3,
      icon: '🧘',
      title: 'Lifestyle & Preventive Astrology',
      subtitle: 'Design your lifestyle around your cosmic blueprint for better balance.',
      features: [
        'Personalized diet & sleep rhythm',
        'Exercise & yoga compatibility',
        'Timing for healing, retreats, or detox'
      ]
    },
    {
      id: 4,
      icon: '🌙',
      title: 'Emotional & Mental Wellbeing',
      subtitle: 'Nurture inner calm by aligning with lunar and planetary rhythms.',
      features: [
        'Moon & mind connection reading',
        'Burnout & anxiety indicators',
        'Remedies: gemstones, mantras & color therapy'
      ]
    },
    {
      id: 5,
      icon: '🔮',
      title: 'Chronic Health & Recovery Insights',
      subtitle: 'Gain long-term clarity on health cycles and recovery periods.',
      features: [
        'Medical astrology consultation',
        'Disease susceptibility analysis',
        'Healing & surgery timing forecast'
      ]
    },
    {
      id: 6,
      icon: '☀️',
      title: 'Energy Optimization',
      subtitle: 'Maximize daily vitality by syncing with solar and lunar energy.',
      features: [
        'Daily energy & stress tracker',
        'Solar/lunar alignment reading',
        'Sleep & biorhythm guidance'
      ]
    }
  ];

  return (
  <section className="bg-sand text-indigoDeep py-8">
      <div className="w-full px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="bg-bone/95 text-indigoDeep rounded-xl p-8 border border-gray-200 hover:border-gray-300 transition-all duration-300 hover:transform hover:scale-105 shadow-lg"
            >
              <div className="text-5xl mb-4">{service.icon}</div>
              <h3 className="font-serif text-2xl mb-2 text-indigoDeep">{service.title}</h3>
              <p className="text-grayWarm text-sm mb-6">{service.subtitle}</p>
              
              <div className="space-y-3">
                <p className="text-xs uppercase tracking-widest text-grayWarm font-semibold">Includes:</p>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-sm text-grayWarm">
                      <span className="text-goldSoft mr-3 mt-1">✦</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button 
                onClick={() => navigate('/booking')}
                className="w-full mt-8 bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-white font-semibold py-3 rounded-lg transition-all duration-300 transform hover:shadow-lg">
                Learn More
              </button>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center bg-white/5 backdrop-blur-md rounded-xl p-12 border border-white/10">
          <p className="text-indigoDeep text-xl mb-8 font-serif">
            Ready to align your health with your cosmic rhythm?
          </p>
          <button 
            onClick={() => navigate('/booking')}
            className="bg-gradient-to-r from-goldSoft to-goldHover hover:from-goldHover hover:to-goldSoft text-white font-bold py-4 px-12 rounded-lg hover:shadow-2xl transition-all duration-300 text-lg transform hover:scale-105">
            🌿 Schedule Your Health Reading
          </button>
        </div>
      </div>
    </section>
  );
};

export default HealthServices;
